import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { withParams } from 'providers/ParamsConsumer';
import { TextField } from '@totalsoft/rocket-ui';
import WrappedLinearProgress from 'components/common/WrappedLinearProgress';

export const OfferFinancialServicesItemComponent = ({
  item,
  loading,
  category,
  onChange,
  editable,
  validationInfo,
  onServiceItemPropertyChange,
  onServiceItemComputeValue,
  saving,
  disabled,
  params,
  categoryIndex,
  itemIndex,
  readOnlyFull
}) => {
  const handleChange = event => {
    onChange(item.serviceTypeId, category ? category.serviceCategoryId : null, event);
  };

  const handleDiscountChange = value => {
    onServiceItemPropertyChange(item.serviceTypeId, category ? category.serviceCategoryId : null, 'discount', value);
  };

  const evaluateCategoryIndex = categoryIndex => {
    if (categoryIndex !== null && categoryIndex !== undefined) return 'category_' + categoryIndex + '_item_' + itemIndex;
    else return 'item_' + itemIndex;
  };

  return (
    <TableRow>
      <TableCell>
        <Checkbox
          id={'offerFinancialServicesCard_itemCard_' + evaluateCategoryIndex(categoryIndex) + '_isSelected'}
          checked={item.selected}
          onChange={handleChange}
          disabled={readOnlyFull || item.mandatory || loading || saving || disabled}
        />
      </TableCell>
      <TableCell>
        {!item.errorMessage ? (
          <span id={'offerFinancialServicesCard_itemCard_' + evaluateCategoryIndex(categoryIndex) + '_name'}>{item.name}</span>
        ) : (
          <span id={'offerFinancialServicesCard_itemCard_' + evaluateCategoryIndex(categoryIndex) + '_name'} style={{ color: 'Red' }}>
            {item.name}
          </span>
        )}
      </TableCell>
      {loading === true ? (
        <TableCell colSpan={2}>
          <WrappedLinearProgress />
        </TableCell>
      ) : (
        <>
          <TableCell>
            <TextField
              id={'offerFinancialServicesCard_itemCard_' + evaluateCategoryIndex(categoryIndex) + '_percent'}
              fullWidth
              isNumeric
              value={!item.percent && item.percent !== 0 ? '' : item.percent}
              inputProps={{ decimalScale: params.cvsChPercent }}
              disabled={true}
            />
          </TableCell>
          <TableCell>
            <TextField
              id={'offerFinancialServicesCard_itemCard_' + evaluateCategoryIndex(categoryIndex) + '_monthlyValue'}
              fullWidth
              isNumeric
              value={!item.serviceMonthlyAmount && item.serviceMonthlyAmount !== 0 ? '' : item.serviceMonthlyAmount}
              disabled={true}
            />
          </TableCell>
        </>
      )}
      <TableCell colSpan={3}>
        <TextField
          id={'offerFinancialServicesCard_itemCard_' + evaluateCategoryIndex(categoryIndex) + '_discount'}
          fullWidth
          isNumeric
          value={item.discount || ''}
          onChange={handleDiscountChange}
          disabled={readOnlyFull || !editable || !item.selected || disabled}
          onBlur={onServiceItemComputeValue}
          error={validationInfo && validationInfo.discount ? true : false}
          helperText={validationInfo && validationInfo.discount}
        />
      </TableCell>
    </TableRow>
  );
};

OfferFinancialServicesItemComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onServiceItemPropertyChange: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  onServiceItemComputeValue: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  category: PropTypes.object,
  categoryIndex: PropTypes.number.isRequired,
  itemIndex: PropTypes.number.isRequired,
  params: PropTypes.object.isRequired,
  readOnlyFull: PropTypes.bool.isRequired
};

export default withTranslation()(withParams(OfferFinancialServicesItemComponent));
